import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";
export const getClientContracts = createAsyncThunk(
  "Accounting/getClientContracts",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contracts`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            params: {
              user_id: id,
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const getClientContracts_ID = createAsyncThunk(
  "Accounting/getClientContracts_ID",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contracts/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const AddClientContracts = createAsyncThunk(
  "Accounting/AddClientContracts",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contracts`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const updateClientContracts = createAsyncThunk(
  "Accounting/updateClientContracts",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contracts/${data.id}/update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteClientContracts = createAsyncThunk(
  "Accounting/deleteClientContracts",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contracts/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
// user_contract_documents

export const AddUserContractDocuments = createAsyncThunk(
  "Accounting/AddUserContractDocuments",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_documents`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "content-type": "multipart/form-data",

              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const UpdateUserContractDocuments = createAsyncThunk(
  "Accounting/UpdateUserContractDocuments",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_documents/${data.id}/update`,
          data.data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "content-type": "multipart/form-data",

              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const DeleteUserContractDocuments = createAsyncThunk(
  "Accounting/DeleteUserContractDocuments",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_documents/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "content-type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

// user_contract_payment_plans
export const getUserContractPaymentPlans = createAsyncThunk(
  "Accounting/getUserContractPaymentPlans",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_payment_plans`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            params: {
              user_contract_id: id,
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const addUserContractPaymentPlans = createAsyncThunk(
  "Accounting/addUserContractPaymentPlans",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_payment_plans`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const updateUserContractPaymentPlans = createAsyncThunk(
  "Accounting/updateUserContractPaymentPlans",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_payment_plans/${data.id}/update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteUserContractPaymentPlans = createAsyncThunk(
  "Accounting/deleteUserContractPaymentPlans",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_payment_plans/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

// user_contract_receipts
export const getUser_contract_receipts = createAsyncThunk(
  "Accounting/getUser_contract_receipts",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_receipts`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            params: {
              user_id: id,
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const addUser_contract_receipts = createAsyncThunk(
  "Accounting/addUser_contract_receipts",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_receipts`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const updateUser_contract_receipts = createAsyncThunk(
  "Accounting/updateUser_contract_receipts",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_receipts/${data.id}/update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteUser_contract_receipts = createAsyncThunk(
  "Accounting/deleteUser_contract_receipts",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_receipts/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const AddUserContractReceiptDocuments = createAsyncThunk(
  "Accounting/AddUserContractReceiptDocuments",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_receipt_documents`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "content-type": "multipart/form-data",

              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const UpdateUserContractReceiptDocument = createAsyncThunk(
  "Accounting/UpdateUserContractReceiptDocument",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_receipt_documents/${data.id}/update`,
          data.data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "content-type": "multipart/form-data",

              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const DeleteUserContractReceiptDocument = createAsyncThunk(
  "Accounting/DeleteUserContractDocuments",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_receipt_documents/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "content-type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

// User_contract_bills
export const getUser_contract_bills = createAsyncThunk(
  "Accounting/getUser_contract_bills",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_bills`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            params: {
              user_id: id,
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const addUser_contract_bills = createAsyncThunk(
  "Accounting/addUser_contract_bills",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_bills`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const updateUser_contract_bills = createAsyncThunk(
  "Accounting/updateUser_contract_bills",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_bills/${data.id}/update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteUser_contract_bills = createAsyncThunk(
  "Accounting/deleteUser_contract_bills",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_bills/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const AddUserContractBillDocuments = createAsyncThunk(
  "Accounting/AddUserContractBillDocuments",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_bill_documents`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "content-type": "multipart/form-data",

              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const UpdateUserContractBillDocuments = createAsyncThunk(
  "Accounting/UpdateUserContractBillDocuments",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_bill_documents/${data.id}/update`,
          data.data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "content-type": "multipart/form-data",

              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const DeleteUserUserContractBillDocuments = createAsyncThunk(
  "Accounting/DeleteUserContractBillDocuments",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_bill_documents/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "content-type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const getUserContractStatements = createAsyncThunk(
  "Accounting/getUserContractStatements",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_statements`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            params: {
              user_contract_id: id,
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const AddUserContractStatements = createAsyncThunk(
  "Accounting/AddUserContractStatements",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_statements`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "content-type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const UpdateUserContractStatements = createAsyncThunk(
  "Accounting/UpdateUserContractStatements",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_statements/${data.id}/update`,
          data.data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "content-type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const DeleteUserUserContractStatements = createAsyncThunk(
  "Accounting/DeleteUserContractStatements",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_statements/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "content-type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

// user_contract_invoices
export const getUser_contract_invoices = createAsyncThunk(
  "Accounting/getUser_contract_invoices",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_invoices`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            params: {
              user_id: id,
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const addUser_contract_invoices = createAsyncThunk(
  "Accounting/addUser_contract_invoices",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_invoices`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const updateUser_contract_invoices = createAsyncThunk(
  "Accounting/updateUser_contract_invoices",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_invoices/${data.id}/update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteUser_contract_invoices = createAsyncThunk(
  "Accounting/deleteUser_contract_invoices",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_invoices/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

// user_contract_invoice_documents
export const getUser_contract_invoice_documents = createAsyncThunk(
  "Accounting/getUser_contract_invoice_documents",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_invoice_documents`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            params: {
              invoice_id: id,
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const addUser_contract_invoice_documents = createAsyncThunk(
  "Accounting/addUser_contract_invoice_documents",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_invoice_documents`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "content-type": "multipart/form-data",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const updateUser_contract_invoice_documents = createAsyncThunk(
  "Accounting/updateUser_contract_invoice_documents",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_invoice_documents/${data.id}/update`,
          data.data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "content-type": "multipart/form-data",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteUser_contract_invoice_documents = createAsyncThunk(
  "Accounting/deleteUser_contract_invoice_documents",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/user_contract_invoice_documents/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

// company_receipts
export const getCompanyReceipts = createAsyncThunk(
  "Accounting/getCompanyReceipts",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/company_receipts`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            params: data && data,
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const AddCompanyReceipts = createAsyncThunk(
  "Accounting/AddCompanyReceipts",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/company_receipts`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "content-type": "multipart/form-data",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const UpdateCompanyReceipts = createAsyncThunk(
  "Accounting/UpdateCompanyReceipts",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/company_receipts/${data.id}/update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "content-type": "multipart/form-data",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const DeleteCompanyReceipts = createAsyncThunk(
  "Accounting/DeleteCompanyReceipts",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/company_receipts/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const addCompany_receipt_documents = createAsyncThunk(
  "Accounting/addCompany_receipt_documents",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/company_receipt_documents`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "content-type": "multipart/form-data",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const updateCompany_receipt_documents = createAsyncThunk(
  "Accounting/updateCompany_receipt_documents",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/company_receipt_documents/${data.id}/update`,
          data.data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "content-type": "multipart/form-data",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteCompany_receipt_documents = createAsyncThunk(
  "Accounting/deleteCompany_receipt_documents",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/company_receipt_documents/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

// CompanyContractBillArray
export const getCompanyContractBill = createAsyncThunk(
  "Accounting/getCompanyContractBill",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/company_bills`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            params: data && data,
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const AddCompanyContractBill = createAsyncThunk(
  "Accounting/AddCompanyContractBill",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/company_bills`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "content-type": "multipart/form-data",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const UpdateCompanyContractBill = createAsyncThunk(
  "Accounting/UpdateCompanyContractBill",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/company_bills/${data.id}/update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "content-type": "multipart/form-data",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const DeleteCompanyContractBill = createAsyncThunk(
  "Accounting/DeleteCompanyContractBill",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/company_bills/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const addCompanyContractBillDocument = createAsyncThunk(
  "Accounting/addCompanyContractBillDocument",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/company_bill_documents`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "content-type": "multipart/form-data",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const updateCompanyContractBillDocument = createAsyncThunk(
  "Accounting/updateCompanyContractBillDocument",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/company_bill_documents/${data.id}/update`,
          data.data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "content-type": "multipart/form-data",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteCompanyContractBillDocument = createAsyncThunk(
  "Accounting/deleteCompanyContractBillDocument",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/company_bill_documents/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

// Employee_contract_receipts
export const getEmployee_contract_receipts = createAsyncThunk(
  "Accounting/getEmployee_contract_receipts",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/employee_receipts`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            params: {
              employee_id: id,
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const addEmployee_contract_receipts = createAsyncThunk(
  "Accounting/addEmployee_contract_receipts",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/employee_receipts`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const updateEmployee_contract_receipts = createAsyncThunk(
  "Accounting/updateEmployee_contract_receipts",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/employee_receipts/${data.id}/update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteEmployee_contract_receipts = createAsyncThunk(
  "Accounting/deleteEmployee_contract_receipts",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/employee_receipts/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const AddEmployeeContractReceiptDocument = createAsyncThunk(
  "Accounting/AddEmployeeContractReceiptDocument",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/employee_receipt_documents`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "content-type": "multipart/form-data",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const UpdateEmployeeContractReceiptDocument = createAsyncThunk(
  "Accounting/UpdateEmployeeContractReceiptDocument",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/employee_receipt_documents/${data.id}/update`,
          data.data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "content-type": "multipart/form-data",

              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const DeleteEmployeeContractReceiptDocument = createAsyncThunk(
  "Accounting/EmployeeContractReceiptDocument",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/employee_receipt_documents/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "content-type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

// EmployeeBills
export const getEmployeeBills = createAsyncThunk(
  "Accounting/getEmployeeBills",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/employee_bills`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            params: {
              employee_id: id,
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const addEmployeeBills = createAsyncThunk(
  "Accounting/addEmployeeBills",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/employee_bills`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const updateEmployeeBills = createAsyncThunk(
  "Accounting/updateEmployeeBills",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/employee_bills/${data.id}/update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteEmployeeBills = createAsyncThunk(
  "Accounting/deleteEmployeeBills",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/employee_bills/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const AddEmployeeContractBillDocument = createAsyncThunk(
  "Accounting/AddEmployeeContractBillDocument",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/employee_bill_documents`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "content-type": "multipart/form-data",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const UpdateEmployeeContractBillDocument = createAsyncThunk(
  "Accounting/UpdateEmployeeContractBillDocument",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/employee_bill_documents/${data.id}/update`,
          data.data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "content-type": "multipart/form-data",

              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const DeleteEmployeeContractBillDocument = createAsyncThunk(
  "Accounting/EmployeeContractBillDocument",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/employee_bill_documents/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "content-type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

// employee_expenses
export const getEmployeeExpenses = createAsyncThunk(
  "Accounting/getEmployeeExpenses",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/employee_expenses`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            params: data && data,
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const addEmployeeExpenses = createAsyncThunk(
  "Accounting/addEmployeeExpenses",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/employee_expenses`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const updateEmployeeExpenses = createAsyncThunk(
  "Accounting/updateEmployeeExpenses",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/employee_expenses/${data.id}/update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteEmployeeExpenses = createAsyncThunk(
  "Accounting/deleteEmployeeExpenses",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/employee_expenses/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

// CompanyTransferVouchers
export const getCompanyTransferVouchers = createAsyncThunk(
  "Accounting/getCompanyTransferVouchers",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/company_transfer_vouchers`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            params: data && data,
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const addCompanyTransferVouchers = createAsyncThunk(
  "Accounting/addCompanyTransferVouchers",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/company_transfer_vouchers`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const updateCompanyTransferVouchers = createAsyncThunk(
  "Accounting/updateCompanyTransferVouchers",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/company_transfer_vouchers/${data.id}/update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteCompanyTransferVouchers = createAsyncThunk(
  "Accounting/deleteCompanyTransferVouchers",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/company_transfer_vouchers/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

// ExpenseList
export const getExpenseList = createAsyncThunk(
  "Accounting/getExpenseList",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/company_expense_lists`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            params: data && data,
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const getExpenseListById = createAsyncThunk(
  "Accounting/getExpenseListById",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/company_expense_lists/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const addExpenseList = createAsyncThunk(
  "Accounting/addExpenseList",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/company_expense_lists`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const updateExpenseList = createAsyncThunk(
  "Accounting/updateExpenseList",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/company_expense_lists/${data.id}/update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteExpenseList = createAsyncThunk(
  "Accounting/deleteExpenseList",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/company_expense_lists/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

// index_counts
export const getIndexCount = createAsyncThunk(
  "Accounting/getIndexCount",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/index/index_counts`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

// collect_today_and_month
export const getCollectTodayAndMonth = createAsyncThunk(
  "Accounting/getCollectTodayAndMonth",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/index/collect_today_and_month`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
// user_contracts_report
export const getUserContractsReport = createAsyncThunk(
  "Accounting/getUserContractsReport",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/index/user_contracts`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            params: data && data,
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
// company_expense_lists

export const getCompanyExpenseLists = createAsyncThunk(
  "Accounting/getCompanyExpenseLists",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/index/company_expense_lists`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            params: data && data,
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
// tasks_not_finished
export const getTasksNotFinished = createAsyncThunk(
  "Accounting/getTasksNotFinished",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/index/tasks_not_finished`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            params: data && data,
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getNumberOfUserContractsPerMonths = createAsyncThunk(
  "Accounting/getNumberOfUserContractsPerMonths",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/Accounting/index/number_of_user_contracts_per_months`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            params: data && data,
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
const AccountingSlice = createSlice({
  name: "Accounting",
  initialState: {
    isAccountingLoading: false,
    error: null,
    ClientContractsArray: null,
    User_contract_receipts_Array: null,
    user_contract_bills_Array: null,
    user_contract_invoices_Array: null,
    CompanyReceiptsArray: null,
    CompanyContractBillArray: null,
    Employee_contract_receipts_Array: null,
    Employee_Bills_Array: null,
    EmployeeExpenses_Array: null,
    CompanyTransferVouchersArray: null,
    ExpenseListArray: null,
    IndexCountArray: null,
    CollectTodayAndMonthArray: null,
    UserContractsReporArray: null,
    CompanyExpenseListsArray: null,
    TasksNotFinishedArray: null,
    NumberOfUserContractsPerMonthsArray: null,
  },

  extraReducers: {
    // getClientContracts
    [getClientContracts.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [getClientContracts.fulfilled]: (state, action) => {
      state.ClientContractsArray = action.payload.data;
      state.isAccountingLoading = false;
    },
    [getClientContracts.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    // getClientContracts_ID
    [getClientContracts_ID.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [getClientContracts_ID.fulfilled]: (state, action) => {
      state.ClientContracts_IDArray = action.payload.data;
      state.isAccountingLoading = false;
    },
    [getClientContracts_ID.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [AddClientContracts.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [AddClientContracts.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [AddClientContracts.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    // updateClientContracts
    [updateClientContracts.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [updateClientContracts.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [updateClientContracts.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },

    [deleteClientContracts.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [deleteClientContracts.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [deleteClientContracts.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    // AddUserContractDocuments
    [AddUserContractDocuments.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [AddUserContractDocuments.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [AddUserContractDocuments.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    // UpdateUserContractDocuments
    [UpdateUserContractDocuments.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [UpdateUserContractDocuments.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [UpdateUserContractDocuments.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    // DeleteUserContractDocuments
    [DeleteUserContractDocuments.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [DeleteUserContractDocuments.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [DeleteUserContractDocuments.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    // addUserContractPaymentPlans
    [addUserContractPaymentPlans.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [addUserContractPaymentPlans.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [addUserContractPaymentPlans.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    // updateUserContractPaymentPlans
    [updateUserContractPaymentPlans.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [updateUserContractPaymentPlans.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [updateUserContractPaymentPlans.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [deleteUserContractPaymentPlans.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [deleteUserContractPaymentPlans.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [deleteUserContractPaymentPlans.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },

    // getUser_contract_receipts
    [getUser_contract_receipts.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [getUser_contract_receipts.fulfilled]: (state, action) => {
      state.User_contract_receipts_Array = action.payload.data;
      state.isAccountingLoading = false;
    },
    [getUser_contract_receipts.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [addUser_contract_receipts.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [addUser_contract_receipts.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [addUser_contract_receipts.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    // updateUser_contract_receipts
    [updateUser_contract_receipts.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [updateUser_contract_receipts.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [updateUser_contract_receipts.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },

    [deleteUser_contract_receipts.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [deleteUser_contract_receipts.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [deleteUser_contract_receipts.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },

    [AddUserContractReceiptDocuments.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [AddUserContractReceiptDocuments.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [AddUserContractReceiptDocuments.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    // UpdateUserContractReceiptDocument
    [UpdateUserContractReceiptDocument.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [UpdateUserContractReceiptDocument.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [UpdateUserContractReceiptDocument.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },

    [DeleteUserContractReceiptDocument.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [DeleteUserContractReceiptDocument.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [DeleteUserContractReceiptDocument.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },

    // getUser_contract_bills
    [getUser_contract_bills.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [getUser_contract_bills.fulfilled]: (state, action) => {
      state.user_contract_bills_Array = action.payload.data;
      state.isAccountingLoading = false;
    },
    [getUser_contract_bills.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [addUser_contract_bills.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [addUser_contract_bills.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [addUser_contract_bills.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    // updateUser_contract_bills
    [updateUser_contract_bills.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [updateUser_contract_bills.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [updateUser_contract_bills.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },

    [deleteUser_contract_bills.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [deleteUser_contract_bills.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [deleteUser_contract_bills.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },

    [AddUserContractBillDocuments.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [AddUserContractBillDocuments.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [AddUserContractBillDocuments.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    // UpdateUserContractBillDocuments
    [UpdateUserContractBillDocuments.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [UpdateUserContractBillDocuments.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [UpdateUserContractBillDocuments.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [DeleteUserUserContractBillDocuments.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [DeleteUserUserContractBillDocuments.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [DeleteUserUserContractBillDocuments.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    // getUserContractStatements
    [getUserContractStatements.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [getUserContractStatements.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [getUserContractStatements.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [AddUserContractStatements.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [AddUserContractStatements.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [AddUserContractStatements.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [UpdateUserContractStatements.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [UpdateUserContractStatements.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [UpdateUserContractStatements.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [DeleteUserUserContractStatements.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [DeleteUserUserContractStatements.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [DeleteUserUserContractStatements.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },

    // getUser_contract_invoices
    [getUser_contract_invoices.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [getUser_contract_invoices.fulfilled]: (state, action) => {
      state.user_contract_invoices_Array = action.payload.data;
      state.isAccountingLoading = false;
    },
    [getUser_contract_invoices.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [addUser_contract_invoices.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [addUser_contract_invoices.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [addUser_contract_invoices.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    // updateUser_contract_invoices
    [updateUser_contract_invoices.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [updateUser_contract_invoices.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [updateUser_contract_invoices.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },

    [deleteUser_contract_invoices.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [deleteUser_contract_invoices.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [deleteUser_contract_invoices.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },

    // getCompanyReceipts
    [getCompanyReceipts.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [getCompanyReceipts.fulfilled]: (state, action) => {
      state.CompanyReceiptsArray = action.payload.data;
      state.isAccountingLoading = false;
    },
    [getCompanyReceipts.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [AddCompanyReceipts.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [AddCompanyReceipts.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [AddCompanyReceipts.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    // UpdateCompanyReceipts
    [UpdateCompanyReceipts.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [UpdateCompanyReceipts.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [UpdateCompanyReceipts.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },

    [DeleteCompanyReceipts.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [DeleteCompanyReceipts.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [DeleteCompanyReceipts.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },

    [addCompany_receipt_documents.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [addCompany_receipt_documents.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [addCompany_receipt_documents.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    // updateCompany_receipt_documents
    [updateCompany_receipt_documents.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [updateCompany_receipt_documents.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [updateCompany_receipt_documents.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },

    [deleteCompany_receipt_documents.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [deleteCompany_receipt_documents.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [deleteCompany_receipt_documents.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },

    // getCompanyContractBill
    [getCompanyContractBill.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [getCompanyContractBill.fulfilled]: (state, action) => {
      state.CompanyContractBillArray = action.payload.data;
      state.isAccountingLoading = false;
    },
    [getCompanyContractBill.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [AddCompanyContractBill.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [AddCompanyContractBill.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [AddCompanyContractBill.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    // UpdateCompanyContractBill
    [UpdateCompanyContractBill.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [UpdateCompanyContractBill.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [UpdateCompanyContractBill.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },

    [DeleteCompanyContractBill.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [DeleteCompanyContractBill.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [DeleteCompanyContractBill.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },

    [addCompanyContractBillDocument.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [addCompanyContractBillDocument.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [addCompanyContractBillDocument.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    // updateCompanyContractBillDocument
    [updateCompanyContractBillDocument.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [updateCompanyContractBillDocument.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [updateCompanyContractBillDocument.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },

    [deleteCompanyContractBillDocument.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [deleteCompanyContractBillDocument.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [deleteCompanyContractBillDocument.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },

    // ==================== EmployeeAccounting ====================

    [getEmployee_contract_receipts.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [getEmployee_contract_receipts.fulfilled]: (state, action) => {
      state.Employee_contract_receipts_Array = action.payload.data;
      state.isAccountingLoading = false;
    },
    [getEmployee_contract_receipts.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [addEmployee_contract_receipts.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [addEmployee_contract_receipts.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [addEmployee_contract_receipts.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [updateEmployee_contract_receipts.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [updateEmployee_contract_receipts.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [updateEmployee_contract_receipts.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },

    [deleteEmployee_contract_receipts.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [deleteEmployee_contract_receipts.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [deleteEmployee_contract_receipts.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },

    [AddEmployeeContractReceiptDocument.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [AddEmployeeContractReceiptDocument.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [AddEmployeeContractReceiptDocument.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [UpdateEmployeeContractReceiptDocument.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [UpdateEmployeeContractReceiptDocument.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [UpdateEmployeeContractReceiptDocument.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },

    [DeleteEmployeeContractReceiptDocument.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [DeleteEmployeeContractReceiptDocument.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [DeleteEmployeeContractReceiptDocument.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },

    [getEmployeeBills.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [getEmployeeBills.fulfilled]: (state, action) => {
      state.Employee_Bills_Array = action.payload.data;
      state.isAccountingLoading = false;
    },
    [getEmployeeBills.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [addEmployeeBills.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [addEmployeeBills.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [addEmployeeBills.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [updateEmployeeBills.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [updateEmployeeBills.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [updateEmployeeBills.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [deleteEmployeeBills.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [deleteEmployeeBills.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [deleteEmployeeBills.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },

    [AddEmployeeContractBillDocument.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [AddEmployeeContractBillDocument.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [AddEmployeeContractBillDocument.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [UpdateEmployeeContractBillDocument.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [UpdateEmployeeContractBillDocument.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [UpdateEmployeeContractBillDocument.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },

    [DeleteEmployeeContractBillDocument.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [DeleteEmployeeContractBillDocument.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [DeleteEmployeeContractBillDocument.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },

    // ============== Employee Expenses ==============

    [getEmployeeExpenses.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [getEmployeeExpenses.fulfilled]: (state, action) => {
      state.EmployeeExpenses_Array = action.payload.data;
      state.isAccountingLoading = false;
    },
    [getEmployeeExpenses.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [addEmployeeExpenses.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [addEmployeeExpenses.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [addEmployeeExpenses.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [updateEmployeeExpenses.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [updateEmployeeExpenses.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [updateEmployeeExpenses.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [deleteEmployeeExpenses.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [deleteEmployeeExpenses.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [deleteEmployeeExpenses.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },

    // ============== Company Transfer Vouchers ==============

    [getCompanyTransferVouchers.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [getCompanyTransferVouchers.fulfilled]: (state, action) => {
      state.CompanyTransferVouchersArray = action.payload.data;
      state.isAccountingLoading = false;
    },
    [getCompanyTransferVouchers.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [addCompanyTransferVouchers.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [addCompanyTransferVouchers.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [addCompanyTransferVouchers.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [updateCompanyTransferVouchers.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [updateCompanyTransferVouchers.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [updateCompanyTransferVouchers.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [deleteCompanyTransferVouchers.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [deleteCompanyTransferVouchers.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [deleteCompanyTransferVouchers.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },

    // ============== ExpenseList ==============
    [getExpenseListById.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [getExpenseListById.fulfilled]: (state, action) => {
      state.ExpenseListByIdArray = action.payload.data;
      state.isAccountingLoading = false;
    },
    [getExpenseListById.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [getExpenseList.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [getExpenseList.fulfilled]: (state, action) => {
      state.ExpenseListArray = action.payload.data;
      state.isAccountingLoading = false;
    },
    [getExpenseList.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [addExpenseList.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [addExpenseList.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [addExpenseList.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [updateExpenseList.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [updateExpenseList.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [updateExpenseList.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [deleteExpenseList.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [deleteExpenseList.fulfilled]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [deleteExpenseList.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    //  ========================== Reports =========================
    [getIndexCount.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [getIndexCount.fulfilled]: (state, action) => {
      state.IndexCountArray = action.payload.data;
      state.isAccountingLoading = false;
    },
    [getIndexCount.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [getCollectTodayAndMonth.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [getCollectTodayAndMonth.fulfilled]: (state, action) => {
      state.CollectTodayAndMonthArray = action.payload.data;
      state.isAccountingLoading = false;
    },
    [getCollectTodayAndMonth.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },

    [getUserContractsReport.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [getUserContractsReport.fulfilled]: (state, action) => {
      state.UserContractsReporArray = action.payload.data;
      state.isAccountingLoading = false;
    },
    [getUserContractsReport.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
    [getCompanyExpenseLists.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [getCompanyExpenseLists.fulfilled]: (state, action) => {
      state.CompanyExpenseListsArray = action.payload.data;
      state.isAccountingLoading = false;
    },
    [getCompanyExpenseLists.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },

    [getTasksNotFinished.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [getTasksNotFinished.fulfilled]: (state, action) => {
      state.TasksNotFinishedArray = action.payload.data;
      state.isAccountingLoading = false;
    },
    [getTasksNotFinished.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },

    [getNumberOfUserContractsPerMonths.pending]: (state, action) => {
      state.isAccountingLoading = true;
    },
    [getNumberOfUserContractsPerMonths.fulfilled]: (state, action) => {
      state.NumberOfUserContractsPerMonthsArray = action.payload.data;
      state.isAccountingLoading = false;
    },
    [getNumberOfUserContractsPerMonths.rejected]: (state, action) => {
      state.isAccountingLoading = false;
    },
  },
});

export default AccountingSlice.reducer;
